// URLs
export const REACT_APP_URL_AGENCY_FIND_ALL = `/api/agency/findAll`;
export const REACT_APP_URL_AGENCY_APPROVE = `/api/agency/approve`;
export const REACT_APP_URL_AGENCY_SAVE = `/api/agency/save`;
export const REACT_APP_URL_CHANGE_PASSWORD = `/api/user/changePassword`;
export const REACT_APP_URL_RESET_PASSWORD = `/api/user/resetPassword`;
export const REACT_APP_URL_SAVE_NEW_PASSWORD = `/api/user/saveNewPassword`;
export const REACT_APP_URL_CLIENT_LIST = `/api/client/list`;
export const REACT_APP_URL_CLIENT_LIST_ALL = `/api/client/findAll`;
export const REACT_APP_URL_V2_CLIENT_FIND_ALL = `/api/v2/client/findAll`;
export const REACT_APP_URL_CLIENT_SAVE = `/api/client/save`;
export const REACT_APP_URL_CLIENT_UPDATE = `/api/client/update`;
export const REACT_APP_URL_CLIENT_VIEW = `/api/client/findById`;
export const REACT_APP_URL_DELETE_CLIENT_DEPARTMENT = `/api/client/deleteDepartment`;
export const REACT_APP_URL_USER_VIEW = `/api/user/findPendingById`;
export const REACT_APP_URL_USER_PENDING_LIST = `/api/user/findPending`;
export const REACT_APP_URL_USER_APPROVE = `/api/user/approve`;
export const REACT_APP_URL_COUNTRY_LIST_ALL = `/api/country/listAll`;
export const REACT_APP_URL_DICTIONARY_LIST_ALL = `/api/dictionary/listAll`;
export const REACT_APP_URL_FUNDING_LIST_ALL = `/api/funding/listAll`;
export const REACT_APP_URL_GET_AUTH_TOKEN = `/oauth/token`;
export const REACT_APP_URL_INT_PAYROLL_ACTIVITY_LIST = `/api/intpayroll/activityList`;
export const REACT_APP_URL_INT_PAYROLL_SAVE = `/api/intpayroll/save`;
export const REACT_APP_URL_LOGIN = `/api/login`;
export const REACT_APP_URL_LOGOUT = `/api/logout`;
export const REACT_APP_URL_OFFICE_FIND_ALL = `/api/office/findAll`;
export const REACT_APP_URL_OFFICE_VIEW = `/api/office/findById`;
export const REACT_APP_URL_ORG_DEPARTMENT_FIND_ALL = `/api/orgdepartment/findAll`;
export const REACT_APP_URL_PERSON_VIEW = `/api/v2/person/findById`;
export const REACT_APP_URL_PERSON_INTERNAL_VIEW = `/api/v2/person/findEmpById`;
export const REACT_APP_URL_PERSON_LIST = `/api/v2/person/list`;
export const REACT_APP_URL_PERSON_SALESMAN_LIST = `/api/person/salesmanList`;
export const REACT_APP_URL_PERSON_SAVE = `/api/person/save`;
export const REACT_APP_URL_PERSON_SAVE_BY_REPORT = `/api/person/saveByReport`;
export const REACT_APP_URL_PERSON_INTERNAL_LIST = `/api/v2/person/findEmp`;
export const REACT_APP_URL_CLIENT_CODE_SAVE = `/api/clientCode/save`;
export const REACT_APP_URL_CLIENT_CODE_DELETE = `/api/clientCode/delete`;
export const REACT_APP_URL_PERSON_UPDATE = `/api/person/update`;
export const REACT_APP_URL_COMMONS_COMMENT_SAVE = `/api/comment/save`;
export const REACT_APP_URL_COMMONS_COMMENT_LIST = `/api/comment/list`;
export const REACT_APP_URL_COMMONS_FILE_UPDATE = `/api/saveFile`;
export const REACT_APP_URL_COMMONS_FILE_DELETE = `/api/deleteFile`;
export const REACT_APP_URL_PERSON_SAVE_LIST = `/api/person/saveList`;
export const REACT_APP_URL_PERSON_SKILL_LIST = `/api/person/skillList`;
export const REACT_APP_URL_PERSON_VALIDATE = `/api/person/validate`;
export const REACT_APP_URL_PERSON_RELATED_COMPANIES = `/api/v2/person/findRelatedCompanies`;
export const REACT_APP_URL_PERSON_SAVE_RELATED_COMPANIES = `/api/v2/person/saveRelatedCompanies`;
export const REACT_APP_URL_ROLE_LIST_ALL = `/api/role/listAll`;
export const REACT_APP_URL_ROLE_VIEW = `/api/role/findById`;
export const REACT_APP_URL_USER_SAVE = `/api/user/save`;
export const REACT_APP_URL_USER_VALIDATE = `/api/user/validate`;
export const REACT_APP_URL_V2_USER_FIND_ALL = `/api/v2/user/findAll`;
export const REACT_APP_URL_CLIENT_FIND_APPROVERS = `/api/v2/client/findApprovers`;
export const REACT_APP_URL_USER_ID = `/api/user/findByUsername`;
export const REACT_APP_URL_USER_UPDATE = `/api/user/update`;
export const REACT_APP_URL_USER_CHANGE_STATUS = `/api/user/changeStatus`;
export const REACT_APP_URL_USER_UNLOCK = `/api/user/unlockUser`;
export const REACT_APP_URL_USER_RESEND_EMAIL = `/api/v2/user/updateEmail`;
export const REACT_APP_URL_PAYROLL_SAVE_LIST = `/api/payroll/saveList`;
export const REACT_APP_URL_PAYROLL_FIND_BY_DAY = `/api/payroll/findByDay`;
export const REACT_APP_URL_PAYROLL_DELETE_DAY = `/api/payroll/deleteDay`;
export const REACT_APP_URL_PAYROLL_DELETE_EMPLOYEE = `/api/payroll/deleteEmployeeFromPayroll`;
export const REACT_APP_URL_PAYROLL_FIND_BY_WEEK = `/api/payroll/findByWeek`;
export const REACT_APP_URL_PAYROLL_SAVE_WEEK = `/api/payroll/saveByWeek`;
export const REACT_APP_URL_PERSON_TERMINATE = `/api/person/terminate`;
export const REACT_APP_URL_PERSON_ACTIVATE = `/api/person/activate`;
export const REACT_APP_URL_PERSON_IDENTIFICATION = `/api/person/findIdentification`;
export const REACT_APP_URL_PERSON_BY_IDENTIFICATION = `/api/person/findByIdentification`;

// user org access (v2) — see user-org-access-api.md
export const REACT_APP_URL_V2_USER_SAVE_ORG_ACCESS = `/api/v2/user/saveOrgAccess`;
export const REACT_APP_URL_V2_USER_REMOVE_ORG_ACCESS = `/api/v2/user/removeOrgAccess`;
export const REACT_APP_URL_V2_USER_ORG_ACCESS_FIND_BY_USERNAME = `/api/v2/user/orgAccess/findByUsername`;

// client branch
export const REACT_APP_URL_CLIENT_BRANCH_FIND_BY_ID = `/api/client/branch/findById`;
// taxes employee
export const REACT_APP_URL_TAXES_EMPLOYEE_SAVE = `/api/person/taxes/save`;
export const REACT_APP_URL_TAXES_EMPLOYEE_FIND_BY_PERSON_ID = `/api/person/taxes/findByPersonId`;
export const REACT_APP_URL_TAXES_EMPLOYEE_FIND_BY_REGION = `/api/taxparams/findByRegion`;
export const REACT_APP_URL_TAXES_EMPLOYEE_DELETE = `/api/taxesEmployee/delete`;

// client
export const REACT_APP_URL_CLIENT_PERSON_CODE_SAVE_BY_FILE = `/api/clientCode/uploadByFile`;
export const REACT_APP_URL_CLIENT_DELETE_POSITION = `/api/client/deletePosition`;
export const REACT_APP_URL_CLIENT_DELETE_BRANCH = `/api/client/branch/delete`;
export const REACT_APP_URL_CLIENT_FIND_BY_ID = `/api/client/findById`;
export const REACT_APP_URL_CLIENT_ACTIVATE = `/api/client/activate`;
export const REACT_APP_URL_CLIENT_DEACTIVATE = `/api/client/deactivate`;

// payroll
export const REACT_APP_URL_PAYROLL_SAVE_BY_WEEK = `/api/payroll/saveByWeek`;
export const REACT_APP_URL_PAYROLL_SAVE_BY_REPORT = `/api/payroll/saveReport`;
export const REACT_APP_URL_PAYROLL_FIND_WEEK_ACTIVE = `/api/getWeekInfo`;
export const REACT_APP_URL_PAYROLL_FIND_POSITIONS = `/api/payroll/findPositions`;
export const REACT_APP_URL_PAYROLL_SAVE_POSITION = `/api/payroll/savePosition`;

// reports
export const REACT_APP_URL_VALIDATE_REPORT = `/api/reports/validateReport`;
export const REACT_APP_URL_FIND_REPORT_CONFIGURATION = `/api/reports/findConfig`;
export const REACT_APP_URL_SAVE_REPORT_CONFIGURATION = `/api/reports/saveConfig`;
export const REACT_APP_URL_FIND_PAYROLL_REPORT = `/api/reports/findPayrollReport`;
export const REACT_APP_URL_FIND_ATTENDANCE_REPORT = `/api/reports/findAttendanceReport`;
export const REACT_APP_URL_FIND_INVOICE_REPORT = `/api/reports/findInvoiceReport`;
export const REACT_APP_URL_GET_DEPARTMENTS_POSITION_LIST_REPORT = `/api/reports/getDeptPosList`;

// Invoice module (backend2): list of a company, one invoice, and the update of its funding id and amounts.
export const REACT_APP_URL_V2_INVOICE_FIND_ALL = `/api/v2/invoice/findAll`;
export const REACT_APP_URL_V2_INVOICE_FIND_BY_ID = `/api/v2/invoice/findById`;
export const REACT_APP_URL_V2_INVOICE_UPDATE = `/api/v2/invoice/update`;

// custom reports
export const REACT_APP_URL_CUSTOM_REPORT_GENERATE = `/api/customReports/generateReport`;
export const REACT_APP_URL_FIND_COLUMN_LIST_REPORT = `/api/customReports/getColumnsList`;
export const REACT_APP_URL_SAVE_USER_CONF_REPORT = `/api/customReports/saveUserConf`;

// Adjustment routes
export const REACT_APP_ROUTE_ADJUSTMENT_NEW = (lang = 'en') => `/adjustment/new/${lang}`;
export const REACT_APP_ROUTE_ADJUSTMENT_CUSTOM = (lang = 'en') => `/customadjustment/${lang}`;

// Adjustment
export const REACT_APP_URL_SAVE_ADJUSTMENT = `/api/adjustment/save`;
export const REACT_APP_URL_FIND_BY_PERSON_ADJUSTMENT = `/api/adjustment/findByPerson`;
export const REACT_APP_URL_GET_ACTIVE_WEEK = `/api/getActiveWeek`;
export const REACT_APP_URL_DELETE_ADJUSTMENT = `/api/adjustment/delete`;

// custompayroll
export const REACT_APP_URL_FIND_PAYROLLCODE = `/api/globalParams/find`;
export const REACT_APP_URL_SAVE_CUSTOM_PAYROLL = `/api/custompayroll/save`;
export const REACT_APP_URL_FIND_CUSTOM_PAYROLL = `/api/custompayroll/find`;
export const REACT_APP_URL_DELETE_CUSTOM_PAYROLL = `/api/custompayroll/delete`;
export const REACT_APP_URL_FIND_CUSTOM_PAYROLL_WEEK = `/api/custompayroll/findByWeek`;
/** Batch save for adjustment flow — wire when backend is ready */
export const REACT_APP_URL_SAVE_CUSTOM_PAYROLL_ADJUSTMENT_BATCH = `/api/custompayroll/adjustment/batch`;

// global params v2
export const REACT_APP_URL_V2_GLOBAL_PARAMS_FIND = `/api/v2/globalParam/find`;
export const REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_CUSTOM_PAYROLL_TYPE = `/api/v2/globalParam/saveCustomPayrollType`;
export const REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_MARITAL_STATUS = `/api/v2/globalParam/saveMaritalStatus`;
export const REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_RELEASE_NOTE = `/api/v2/globalParam/saveReleaseNote`;
export const REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_DICTIONARY = `/api/v2/globalParam/saveDictionary`;
export const REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_TAX_PARAMS = `/api/v2/globalParam/saveTaxParams`;
export const REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_ZIP_CODE = `/api/v2/globalParam/saveZipCode`;
export const REACT_APP_URL_V2_GLOBAL_PARAM_SAVE_ORG_DEPARTMENT = `/api/v2/globalParam/saveOrgDepartment`;
export const REACT_APP_URL_GLOBAL_PARAMS_FIND = `/api/globalParams/find`;
export const REACT_APP_URL_GLOBAL_PARAMS_SAVE = `/api/globalParams/save`;

export const REACT_APP_URL_SAVE_TIMEOFF = `/api/timeoff/request`;
export const REACT_APP_URL_FIND_TIMEOFF = `/api/timeoff/findTimeOff`;
export const REACT_APP_URL_FIND_TIMEOFF_BY_DATE = `/api/timeoff/findByDate`;
export const REACT_APP_URL_FIND_TIMEOFF_BY_EMPLOYEE = `/api/timeoff/findByUser`;
export const REACT_APP_URL_FIND_TIMEOFF_ALL_EMPLOYEES = `/api/timeoff/admin/findAllEmployees`;
export const REACT_APP_URL_REJECT_TIMEOFF = `/api/timeoff/reject`;
export const REACT_APP_URL_APPROVE_TIMEOFF = `/api/timeoff/approve`;
export const REACT_APP_URL_TIMEOFF_FIND_SUMMARY_USER = `/api/timeoff/findByUser`;
export const REACT_APP_URL_TIMEOFF_FIND_USER = `/api/timeoff/findSummaryByUser`;
export const REACT_APP_URL_TIMEOFF_ADMIN_FIND_ALL_EMPLOYEES = `/api/timeoff/admin/findAllEmployees`;
export const REACT_APP_URL_CANCEL_TIMEOFF = `/api/timeoff/cancel`;
export const REACT_APP_URL_TIMEOFF_FIND = `/api/timeoff/admin/findSummary`;

// person timeoff management
export const REACT_APP_URL_PERSON_TIMEOFF_FIND_BY_USER = `/api/persontimeoff/findByUser`;
export const REACT_APP_URL_PERSON_TIMEOFF_SAVE = `/api/persontimeoff/save`;
export const REACT_APP_URL_PERSON_TIMEOFF_DELETE = `/api/persontimeoff/delete`;

// release notes
export const REACT_APP_URL_FIND_RELEASE_NOTES = `/api/globalParams/releasenotes/findAllByRelease/`;

// attendance
export const REACT_APP_URL_FIND_ATTENDANCE = `/api/attendance/find`;
export const REACT_APP_URL_SAVE_ATTENDANCE = `/api/attendance/save`;

// mypayroll-payroll-history
export const REACT_APP_URL_FIND_PAYROLL_BY_PERSON = `/api/payrollHistory/findByEmployee`;
// v2 — includes adjustments and custom payrolls per client/week
export const REACT_APP_URL_V2_FIND_PAYROLL_BY_PERSON = `/api/v2/payrollHistory/findByEmployee`;

// Dashboard Charts
export const REACT_APP_URL_FIND_LOGIN_BY_OFFICE = `/api/summary/findLoggedOffUsers`;
export const REACT_APP_URL_FIND_LAST_MONTH_CLIENT_HOURS = `/api/summary/findTotalClientHours`;
export const REACT_APP_URL_FIND_LAST_SEVEN_DAYS_HOURS_SUM_BY_ORG = `/api/summary/findTotalOrgHoursByDays`;
export const REACT_APP_URL_FIND_TOTAL_CLIENT_EMPLOYEES_BY_DAY = `/api/summary/findTotalClientEmployeesByDay`;
export const REACT_APP_URL_FIND_VARIATION_BY_ORG_ID = `/api/summary/findOrgVariation`;
export const REACT_APP_URL_FIND_EMPLOYEE_WEEKLY_HOURS = `/api/summary/findEmployeeWeeklyHours`;
export const REACT_APP_URL_EMPLOYEE_DASHBOARD_SUMMARY = `/api/v2/dashboard/employee/summary`;

// recaptcha
export const REACT_APP_RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const REACT_APP_RECAPTCHA_V2_SITE_KEY = process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY;

const firstEnv = (...keys) => {
  for (const key of keys) {
    const v = process.env[key];
    if (v != null && String(v).trim() !== '') {
      return String(v).trim();
    }
  }
  return undefined;
};

// Normalize root "/" (and trailing slashes) to "" so that baseUrl + "/api/..."
// yields "/api/..." (relative, same-origin) instead of "//api/..." which the
// browser reads as a protocol-relative URL (host = "api") → CORS.
const normalizeBase = (v) => (v == null ? v : v === '/' ? '' : v.replace(/\/+$/, ''));

export const REACT_APP_BACKEND_1_BASE_URL = normalizeBase(firstEnv('REACT_APP_BACKEND_1_BASE_URL', 'REACT_APP_BASE_URL_TEMPEDGE'));
export const REACT_APP_BACKEND_2_BASE_URL = normalizeBase(firstEnv('REACT_APP_BACKEND_2_BASE_URL', 'REACT_APP_BASE_URL_TEMPEDGE_2'));

/** @deprecated use REACT_APP_BACKEND_1_BASE_URL */
export const REACT_APP_BASE_URL_TEMPEDGE = REACT_APP_BACKEND_1_BASE_URL;

export const REACT_APP_BASE_URL_FACERE_COGNITION = process.env.REACT_APP_BASE_URL_FACERE_COGNITION;

export const REACT_APP_BACKEND_1_USER = firstEnv('REACT_APP_BACKEND_1_USER', 'REACT_APP_TEMPEDGE_USER');
export const REACT_APP_BACKEND_1_PASSWORD = firstEnv('REACT_APP_BACKEND_1_PASSWORD', 'REACT_APP_TEMPEDGE_PASSWORD');
/** @deprecated */
export const REACT_APP_TEMPEDGE_USER = REACT_APP_BACKEND_1_USER;
/** @deprecated */
export const REACT_APP_TEMPEDGE_PASSWORD = REACT_APP_BACKEND_1_PASSWORD;

export const REACT_APP_BACKEND_2_USER = firstEnv('REACT_APP_BACKEND_2_USER', 'REACT_APP_TEMPEDGE_USER_2');
export const REACT_APP_BACKEND_2_PASSWORD = firstEnv('REACT_APP_BACKEND_2_PASSWORD', 'REACT_APP_TEMPEDGE_PASSWORD_2');
/** @deprecated */
export const REACT_APP_BASE_URL_TEMPEDGE_2 = REACT_APP_BACKEND_2_BASE_URL;
/** @deprecated */
export const REACT_APP_TEMPEDGE_USER_2 = REACT_APP_BACKEND_2_USER;
/** @deprecated */
export const REACT_APP_TEMPEDGE_PASSWORD_2 = REACT_APP_BACKEND_2_PASSWORD;

// Backend v2 API endpoints
export const REACT_APP_URL_V2_NOTIFICATION_FIND_ALL = `/api/v2/notification/findAll`;
export const REACT_APP_URL_V2_OAUTH_TOKEN = `/api/v2/oauth/token`;
export const REACT_APP_URL_V2_OAUTH_REFRESH_TOKEN = `/api/v2/oauth/refreshtoken`;
export const REACT_APP_URL_V2_OAUTH_VALIDATE = `/api/v2/oauth/validate`;
export const REACT_APP_URL_V2_OAUTH_LOGIN = `/api/v2/oauth/login`;
export const REACT_APP_URL_V2_LOGOUT = `/api/v2/oauth/logout`;

// Feature Flags
// true = OTP still in config on backend: skip OTP UI/validation, go to org selection or dashboard.
// false = OTP released: show OTP inputs and validate when login_response_code is TE00.
export const REACT_APP_ENABLE_CODE_VERIFICATION = process.env.REACT_APP_ENABLE_CODE_VERIFICATION === 'true';

// Candidate

export const REACT_APP_URL_CANDIDATE_SAVE = `/api/candidate/save`;
export const REACT_APP_URL_CANDIDATE_FIND_ALL = `/api/candidate/findByRegistrationToken`;
export const REACT_APP_URL_CANDIDATE_APPLY = `/api/candidate/apply`;
export const REACT_APP_URL_CANDIDATE_FIND_BY_REGISTRATION = `/api/candidate/findByConfirmationToken`;
// Employee Account
export const REACT_APP_URL_ACCOUNT_CREATE = `/api/account/save`;
export const REACT_APP_URL_ACCOUNT_FIND_PERSON = `/api/account/find`;
export const REACT_APP_URL_ACCOUNT_DELETE = `/api/account/delete`;

// Worker Comp (API v2 / backend 2)
export const REACT_APP_URL_WORKER_COMP_SAVE = `/api/v2/workersComp/save`;
export const REACT_APP_URL_WORKER_COMP_FIND_ALL = `/api/v2/workersComp/findAll`;
export const REACT_APP_URL_WORKER_COMP_DELETE = `/api/v2/workersComp/delete`;
// Zip Code
export const REACT_APP_URL_ZIP_CODE_SAVE = `/api/zipcode/save`;

// global params
export const REACT_APP_URL_GLOBAL_PARAMS_FIND_APPROVERS = `/api/globalParams/findAllTimeOffApprovers`;

// profile
export const REACT_APP_URL_PROFILE_VIEW = `/api/user/viewProfile`;
export const REACT_APP_URL_PROFILE_UPDATE = `/api/user/updateProfile`;

// home
export const REACT_APP_ROUTE_HOME = (lang = 'en') => `/home/${lang}`;

// employee payroll
export const REACT_APP_URL_EMPLOYEE_PAYROLL = `/api/payroll/findByEmployee`;
export const REACT_APP_URL_EMPLOYEE_PAYROLL_SAVE = `/api/payroll/saveByEmployee`;
export const REACT_APP_URL_EMPLOYEE_PAYROLL_CLIENT_LIST = `/api/payroll/findEmployeeClientList`;

// find file
export const REACT_APP_URL_FIND_FILE = `/api/findFile`;
export const REACT_APP_URL_FILE_FIND_BY_ID = `/api/v2/file/findById`;
